import { type Color } from "../UI/Text";

export interface StatusInfo {
  status: Color;
  text: string;
}

export function getStatusInfo(
  balance: { balance?: number } | undefined,
  tenant: { loyer_hc?: number; charges?: number } | undefined,
): StatusInfo | null {
  if (!balance || !tenant) return null;

  const monthlyRent = (tenant.loyer_hc || 0) + (tenant.charges || 0);
  const balanceValue = balance.balance ?? 0;

  if (balanceValue >= 0) {
    return { status: "success", text: "À jour" };
  } else if (balanceValue < monthlyRent * -1) {
    return { status: "danger", text: "Impayé" };
  } else {
    return { status: "warning", text: "Retard" };
  }
}
